import { create } from "zustand";
import { User } from "@/lib/types";
import { devtools } from "zustand/middleware";

type AuthStore = {
  user: User | null;
  setUser: (user: User | null) => void;
};

const useAuth = create<AuthStore>()(
  devtools(
    (set) => ({
      user: null,
      setUser: (user: User | null) => set({ user }),
    }),
    { name: "auth" }
  )
);

export default useAuth;
